import { useDispatch, useSelector } from 'react-redux';
import { togglePopover } from '../redux/Slices/popoverSlice';
import { useRef, useState } from 'react';

const useHandlePopoverClick = () => {
    const dispatch = useDispatch();
    const popoverState = useSelector((state) => state.popover);
    const [popoverTarget, setPopoverTarget] = useState(null); // Store DOM element in React state

    const handlePopoverClick = (e, contentId, props = {}) => {
        const target = e?.currentTarget || e;
        setPopoverTarget(target);

        const keepPosition = props?.isPopPositionChanged === false;

        // Determine which target/position to use
        const effectiveTargetId = keepPosition && popoverState?.targetId
            ? popoverState.targetId
            : target.id;

        const computeFromElement = () => {
            const el = document.getElementById(effectiveTargetId) || target;
            const rect = el.getBoundingClientRect();
            return { top: rect.bottom, left: rect.left };
        };

        // Close if same content on same anchor
        if (
            popoverState.isVisible &&
            popoverState.contentId === contentId &&
            popoverState.targetId === effectiveTargetId
        ) {
            dispatch(togglePopover({ contentId: null, position: { top: 0, left: 0 }, targetId: null }));
        } else {
            const position = keepPosition && popoverState?.position
                ? popoverState.position
                : computeFromElement();

            dispatch(togglePopover({
                contentId,
                position,
                targetId: effectiveTargetId,
                props,
            }));
        }
    };



    return { popoverState, handlePopoverClick, popoverTarget };
};

export default useHandlePopoverClick;
